import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'papercraft-launch-deadline';
const WINDOW_MS = 15 * 60 * 1000;
function readDeadline(): number {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = Number(stored);
      if (!Number.isNaN(parsed)) return parsed;
    }
  } catch {
    /* sessionStorage unavailable — fall through */
  }
  const deadline = Date.now() + WINDOW_MS;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, String(deadline));
  } catch {
    /* ignore */
  }
  return deadline;
}
export function Countdown() {
  const [remaining, setRemaining] = useState<number | null>(null);
  useEffect(() => {
    const deadline = readDeadline();
    const update = () => setRemaining(Math.max(0, deadline - Date.now()));
    update();
    const interval = window.setInterval(update, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const totalSeconds = Math.floor((remaining ?? WINDOW_MS) / 1000);
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return <div className="flex items-center gap-4 rounded-card border border-hairline bg-paper p-4 sm:p-5" data-id="element-35" data-mp="t1ag58ljsaa3">
      <div className="flex items-baseline gap-1 font-display text-[36px] font-bold leading-none tabular-nums tracking-[-0.03em] text-ink sm:text-[42px]" data-id="element-36" data-mp="17pojdkmvm0r6">
        <span data-id="element-37" data-mp="f22du6u38m1o">{minutes}</span>
        <span className="text-clay" data-id="element-38" data-mp="f3die8vcxxtu">:</span>
        <span data-id="element-39" data-mp="f4ewynbl12gb">{seconds}</span>
      </div>

      <div data-id="element-40" data-mp="a40vxp8eesrs">
        <p className="text-[14px] font-semibold leading-snug text-ink" data-id="element-41" data-mp="a498th4ity2z">
          Your launch discount is reserved for:
        </p>
        <p className="mt-1 text-[13px] leading-[1.5] text-muted" data-id="element-42" data-mp="o4bl8nu27zau">
          Once the timer ends, the promotional price may no longer be available.
        </p>
      </div>
    </div>;
}